<template>
  <div class="dovemed-container">
    <div class="dovemed-wrapper signup-page">
      <div class="signup-container" style="max-width: 600px">
        <h2 class="hyper-link mb-3 text-center">
          You are logged in as an administrator for
        </h2>
        <div class="mt-5 mb-2">
          <ProviderCard
            :info="info"
            :type="type"
            :hideBtn="true"
            @addVirtualDocToCircle="addVirtualDocToCircle($event)"
          />
        </div>
        <span class="not-mine cp" :style="{ color: getPrimaryColor() }"
          >This is not my {{ type }}</span
        >
        <div class="row mt-3">
          <div class="buttons-group mt-4 text-right col-md-12 col-sm-12 mb-4">
            <button
              class="dovemed-button primary-border hyper-link"
              @click="redirectBack()"
              :style="{
                border: '1px solid ' + getPrimaryColor(),
                color: getPrimaryColor(),
                background: '#fff',
              }"
            >
              BACK
            </button>
            <a-button
              :loading="loading"
              type="submit"
              class="dovemed-button font-white ml-4 primary-button"
              :style="{ background: getPrimaryColor() }"
              @click.prevent="handleSubmit"
              >NEXT</a-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import ProviderCard from "../../home/provider/ProviderCard";
import Repository from "../../../repositories/Repository";

export default {
  name: "LoginAdminSelect",
  components: {
    ProviderCard,
  },
  data() {
    return {
      type: undefined,
      info: {},
      user: {},
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.type = this.$router.currentRoute.query.role;
    this.info = JSON.parse(this.$router.currentRoute.query.info);
    this.user = JSON.parse(this.$router.currentRoute.query.user);
  },
  methods: {
    redirectBack() {
      this.$router.go(-1);
    },
    handleSubmit() {
      this.$store
        .dispatch("Auth/login", { data: this.user })
        .then((res) => {
          const user = this.$store.state.User.user;
          this.loading = false;
          Repository.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${user.user.token}`;
          // this.$router.push({ path: "/circles/all" });
          // this.$router.push({path: `/${this.currentCircle.condition_type}/home`})
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: err.response.data.message,
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style>
.not-mine {
  font-family: Lato;
  font-size: 16px;
  font-weight: 400;
  padding-bottom: 3px;
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/Signup/UserProfile/LoginAdminSelect.vue